<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 16 16"
       @click="$emit('click')">
    <path d="M9.36 1.988l.807-1.21a.4.4 0 1 1 .666.444l-.725 1.087c1.084.594 1.803 1.633 1.803 2.815 0 .077-.004.47-.01.545H4.1a14.889 14.889 0 0 1-.012-.545c0-1.145.675-2.155 1.702-2.758L5.15 1.192a.4.4 0 1 1 .702-.384l.667 1.22c.458-.16.957-.249 1.482-.249.479 0 .937.074 1.36.21zm-6.485 4.27a.84.84 0 0 1 .839.835v3.634c0 .46-.377.835-.839.835H2.84A.838.838 0 0 1 2 10.727V7.093c0-.458.377-.834.839-.834h.036zm1.24 5.178V6.268h7.77v5.168a.77.77 0 0 1-.771.766h-.824v1.962c0 .46-.377.836-.84.836h-.035a.84.84 0 0 1-.84-.836v-1.962h-1.15v1.962a.84.84 0 0 1-.84.836h-.037a.84.84 0 0 1-.838-.836v-1.962h-.824a.77.77 0 0 1-.77-.766zM6.32 4.273a.5.5 0 1 0 0-1 .5.5 0 1 0 0 1zm3.184 0a.5.5 0 1 0 0-1 .5.5 0 1 0 0 1zm3.657 1.986a.84.84 0 0 1 .839.834v3.634c0 .46-.376.835-.839.835h-.035a.84.84 0 0 1-.84-.835V7.093a.84.84 0 0 1 .84-.834h.035z" :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>